<div class="form-frame">
  <app-logo></app-logo>

  <div class="form-frame__body">
    <img
      src="assets/img/ok.svg"
      alt="OK"
      class="form-frame__body-icon">

    <h2
      class="form-frame__body-title">
      {{'REGISTER_SUCCESS_PAGE.TITLE' | translate}}
    </h2>

    <p class="form-frame__body-description">
      {{'REGISTER_SUCCESS_PAGE.DESCRIPTION' | translate}}
    </p>

  </div>

  <app-lang-select></app-lang-select>
</div>
